import { PkCommonFooter } from "../../components/common/PkCommonFooter";
import Benefits from "./benefits/Benefits";
import Features from "./features/Features";
import Header from "./header/Header";
import Problems from "./problems/Problems";
import Proof from "./proof/Proof";
import Showcase from "./showcase/Showcase";
import Vision from "./vision/Vision";
export function LandingPage() {
  return (
    <>
      <Header />
      <Problems />
      <Features />
      <Showcase />
      <Benefits />
      <Vision />
      <Proof />
      <PkCommonFooter />
    </>
  );
}
